module.exports = __webpack_public_path__ + "static/media/marker-logo.fc7b24c6.png";